// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8916d3b8d7053a50","7065":"b87e79427d2ffbd3","8552":"7e0a93d022dcae15"}[chunkId] + ".css";
};